<template>
  <div>
    <button @click="$emit('click')" :style="`background-color: ${background}; color: ${color}`" :class="getMergedClassList()"><span v-if="!loading">{{ text }}</span><span v-else><div class="ball-pulse"><div></div><div></div><div></div></div></span></button>
  </div>
</template>
  
<script>
export default {
  name: "Button",
  props: ["classes", "text", "background", "color", "loading"],
  methods: {
    getMergedClassList () {
      return Object.assign({
        "button-base": true
      }, this.classes ? this.classes : {});
    }
  }
}
</script>
  
<style scoped>
.button-base {
  box-shadow: 3px 2px 13px -4px #000000;
  border-radius: .2em;
  border: solid 1px rgba(0,0,0,0);
  font-size: 1.1em;
  transition: all .2s;
  padding: 0.3em 1em;
  cursor: pointer;
  min-height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-base:hover {
  filter: invert(0.1);
}

</style>